import React, { Component } from "react";
import { connect } from "react-redux";

import { createPromotionType } from "actions/promotionType";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/PromotionType/Form";

class PromotionTypeCreate extends Component {
  handleFormSubmit = data => {
    this.createPromotionType(data);
  };

  createPromotionType(data) {
    const { toggleNotification, toggleFullPageSpinner, createPromotionType, history } = this.props;
    toggleFullPageSpinner(true);
    createPromotionType(data)
      .then(() => {
        toggleNotification(true, { message: "Created PromotionType Success", infoClassName: "is-success" });
        history.push(`/promotion-types`);
      })
      .catch(e => {
        toggleNotification(true, { message: e.message, infoClassName: "is-danger" });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return <Form handleFormSubmit={this.handleFormSubmit} />;
  }
}

export default connect(
  null,
  {
    createPromotionType,
    toggleFullPageSpinner,
    toggleNotification
  }
)(PromotionTypeCreate);



// WEBPACK FOOTER //
// ./src/pages/PromotionType/Create/index.js